"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AvailabilityLabelView = ({ description }) => react_1.default.createElement("span", { className: `label ${description.includes('Skladem') ? 'label--on-stock' : 'label--available-sooner'}`, title: description }, description);
exports.default = AvailabilityLabelView;
